import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
export const RunStatePanel = ({
  icon,
  title,
  body,
  action,
}: {
  icon: React.ReactNode;
  title: string;
  body: string;
  action?: React.ReactNode;
}) => (
  <Stack
    align="center"
    justify="center"
    gap="md"
    fullWidth
    className="flex-1 px-8 py-16"
  >
    {icon}
    <Stack gap="xs" align="center">
      <Typography variant="subtitleW3">{title}</Typography>
      <Typography
        variant="bodyW3"
        textColor="secondary"
        className="max-w-[460px] text-center"
      >
        {body}
      </Typography>
    </Stack>
    {action}
  </Stack>
);
